export class SimpleSound {
    constructor({ src, volume = 1, onplayerror } = {}) {
        const url = Array.isArray(src) ? src[0] : src;
        this.audio = new Audio(url);
        this.audio.volume = volume;
        this.audio.preload = 'none';

        if (onplayerror) {
            this.audio.addEventListener('error', (e) => onplayerror(null, e));
        }
    }

    play() {
        this.audio.currentTime = 0;
        return this.audio.play();
    }

    stop() {
        this.audio.pause();
        this.audio.currentTime = 0;
    }
}
